<template>
    <div class="cs-offerwall__filterContainer" :class="[getCountFilters() > 0 ? 'cs-offerwall__filterContainer--active' : '']" v-on:click="$emit('filterClick')">
        <div class="cs-offerwall__filterCounter" v-if="isMultiselect && getCountFilters() > 0">{{getCountFilters()}}</div>
        <div class="cs-offerwall__filterTitle" :class="[getCountFilters() > 0 ? 'cs-offerwall__filterTitle--active' : '']">{{title}}</div>
        <div class="cs-offerwall__filterArrow--down"></div>
    </div>
</template>

<script>
export default{
    name: 'OfferWallFilterComponent',
    props: [
        "filter", 
        "title",
        "isMultiselect",
        "selectedFilters"
    ],
    emits: ['filterClick'],
    data: function(){
        return{
        }
    },
    methods: {
        getCountFilters(){
            return this.selectedFilters.length;
        }
    },
    mounted: function() {
    }
}
</script>

<style lang="scss" scoped>
    .cs-offerwall__filter{
        &Container{
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 700;
            color: #0194F4;
            background: white;
            border-radius: 25px;
            padding: 5px 10px;
            margin-right: 10px;
            margin-top: 10px;
            margin-left: 10px;

            @media screen and (min-width: 768px) {
                padding: 5px 15px;
            }
            &--active{
                background: #223B5F;
                .cs-offerwall__filterArrow--down{
                    border-color: white;
                }
            }
        }

        &Counter{
            padding: 3px;
            border-radius: 100%;
            background: #0194F4;
            width: 16px;
            height: 16px;
            font-size: 14px;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 5px;
        }

        &Title{
            margin-right: 10px;
            &--active{
                color: white;
            }
        }

        &Arrow--down{
            width: 6px;
            height: 6px;
            border-right: 3px solid #000;
            border-bottom: 3px solid #000;
            transform: rotate(45deg);
            margin-right: 5px;
        }
    }
</style>